module.exports = __webpack_public_path__ + "media/images/pharma_admin/icons/link-0f5b89c6367138a669f712e5336f5245.svg";